import { StringParam, withDefault } from 'use-query-params';
import { SchemaFilterType, SortDir } from '@ui/src';

export const columns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'createdAt',
    label: 'Creation Date',
    sortable: false,
  },
  {
    name: 'name',
    label: 'Name',
    sortable: false,
  },
  {
    name: 'expirationDate',
    label: 'Exp. Date',
    sortable: false,
  },
  {
    name: 'status',
    label: 'Status',
  },
];

export const defaultSorter = {
  sortProp: columns[3].name,
  sortDir: SortDir.ASC,
};

export const schema = {
  sortProp: {
    value: withDefault(StringParam, defaultSorter.sortProp),
    type: SchemaFilterType.STRING,
  },
  sortDir: {
    value: withDefault(StringParam, defaultSorter.sortDir),
    type: SchemaFilterType.STRING,
  },
};

export const filtersSchema = [];

export const columnsLabels = {};
